import { render, staticRenderFns } from "./PatentNoteTypeForm.vue?vue&type=template&id=555d2c0a&"
import script from "./PatentNoteTypeForm.vue?vue&type=script&lang=js&"
export * from "./PatentNoteTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentNoteTypeForm.vue?vue&type=style&index=0&id=555d2c0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports